import * as fromDatatype from '../datatype-library/index';

export interface app_tenant_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  subscription_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  ranks: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  obj_access: fromDatatype.VarcharDatatypeInterface;
  obj_status: fromDatatype.VarcharDatatypeInterface;
  host_approved: boolean;
  rsa_private_key: fromDatatype.TextDatatypeInterface;
  rsa_public_key: fromDatatype.TextDatatypeInterface;
  rsa_expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  rsa_properties: fromDatatype.JsonDatatypeInterface;
  rds_type: fromDatatype.VarcharDatatypeInterface;
}

export class app_tenant_hdr_RowClass
  implements app_tenant_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  code: fromDatatype.VarcharDatatypeInterface;
  parent_guid: fromDatatype.GuidDataFieldInterface;
  subscription_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  description: fromDatatype.TextDatatypeInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  ranks: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  date_created: fromDatatype.TimestampTzDatatypeInterface;
  date_updated: fromDatatype.TimestampTzDatatypeInterface;
  obj_type: fromDatatype.VarcharDatatypeInterface;
  obj_access: fromDatatype.VarcharDatatypeInterface;
  obj_status: fromDatatype.VarcharDatatypeInterface;
  host_approved: boolean;
  rsa_private_key: fromDatatype.TextDatatypeInterface;
  rsa_public_key: fromDatatype.TextDatatypeInterface;
  rsa_expiry_date: fromDatatype.TimestampTzDatatypeInterface;
  rsa_properties: fromDatatype.JsonDatatypeInterface;
  rds_type: fromDatatype.VarcharDatatypeInterface;
}
